import { render, staticRenderFns } from "./CoursesDesktop.vue?vue&type=template&id=4a268b44&scoped=true"
import script from "./CoursesDesktop.vue?vue&type=script&lang=js"
export * from "./CoursesDesktop.vue?vue&type=script&lang=js"
import style0 from "./CoursesDesktop.vue?vue&type=style&index=0&id=4a268b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a268b44",
  null
  
)

export default component.exports